import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../Modal';
import { Button } from '../../Button/Button';
import { useAuth } from 'hooks/useAuth';
import PublicRoute from 'enums/publicRoutes';
import { adminPath } from 'enums/adminRoutes';
import { StyledWholesaleGateModal } from './style';

export interface WholesaleGateModalProps {
  open: boolean;
  onClose: () => void;
}

// Shown when a visitor tries to add a wholesale product to the cart
// without being logged in, or without an active wholesale contract.
export const WholesaleGateModal = ({
  open,
  onClose,
}: WholesaleGateModalProps) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { user } = useAuth();

  const needsLogin = !user?.authenticated;
  const variant = needsLogin ? 'login' : 'contract';

  const handleAction = () => {
    onClose();

    if (needsLogin) {
      const comesFrom =
        `${window.location.pathname}${window.location.search}`.replace(
          /^\//,
          ''
        );
      localStorage.setItem('comesFrom', comesFrom);
      navigate(PublicRoute.LOGIN);
    } else {
      window.location.href = adminPath.farmContracts();
    }
  };

  const bold = (chunks: ReactNode) => <b>{chunks}</b>;

  return (
    <Modal open={open} onCancel={onClose} footer={null} width={480}>
      <StyledWholesaleGateModal>
        <p>
          <FormattedMessage
            id={`wholesale_gate.${variant}_text_1`}
            values={{ b: bold }}
          />
        </p>
        <p>
          <FormattedMessage
            id={`wholesale_gate.${variant}_text_2`}
            values={{ b: bold }}
          />
        </p>
        <Button
          type={'primary'}
          className={'wholesale-gate-action-btn'}
          label={intl.formatMessage({ id: `wholesale_gate.${variant}_button` })}
          onClick={handleAction}
        />
      </StyledWholesaleGateModal>
    </Modal>
  );
};
